import Thumbnail, { DROP_SHADOW_VALUE, PAGINATION_THUMBNAIL_WIDTH } from './thumbnail';

export default Thumbnail;
export { DROP_SHADOW_VALUE, PAGINATION_THUMBNAIL_WIDTH };
